<template>
<div class="chapter">
<div class="inner_page">
<p class="figa"><a id="page1"></a><a id="page2"></a><img alt="" src="images/pg3_1.jpg"/></p>
<p class="copyg"><i>Simply Stars</i> is designed not only for the quiltmaker, but also for those who are interested in teaching it as a class. A suggested class outline follows the projects.</p>
<p class="copy">Editor: Lee Jonsson</p>
<p class="copy">Technical Editor: Joyce Engels Lytle</p>
<p class="copy">Copy Editor: Judith M. Moretz</p>
<p class="copy">Cover and book design: Rose Sheifer Graphic Productions</p>
<p class="copy">Electronic illustrations: Rose Sheifer Graphic Productions</p>
<p class="copy">Photography: Sharon Risedorph</p>
<p class="copy">Author photo: Michael Stefanski</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?20aea571